import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";
import { ProfileProvider } from "../contexts/ProfileContext"; // Import ProfileProvider
import { Dropdown, Modal } from "react-bootstrap";
import RegisterSocial from "../components/RegisterSocial";
import Balance from "../components/Balance";
import axios from "axios";




function Dashboard() {
  const [profile, setProfile] = useState(null); // Store profile data
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [showLinkAccount, setLinkAccount] = useState(false);
  const [showBalance, setShowBalance] = useState(false);

  const addAccount = () => {
	  setLinkAccount(true);
  };
  // Logout the user
  const handleLogout = async () => {
	try {
	  localStorage.removeItem("accessToken");
	  window.location.href = "/login"; 
	} catch (err) {
	  console.error("Error during logout:", err);
	} 
  };

  // Fetch profile info via POST request
  const fetchProfileInfo = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) throw new Error("No access token found. Please log in.");

      const response = await fetch(`https://api.viralgpt.com/auth/profile`, {
        method: "GET", // Use POST method to fetch profile data
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch profile info.");
      }

      const profileData = await response.json();
      setProfile(profileData.profile); // Assuming the response contains a `profile` field
	  let rankSet = false;
	  
		for (var i of Object.keys(profileData.profile.socials)) {
			
			if (profileData.profile.socials[i].planName === "pro" || profileData.profile.socials[i].planName === "basic") {
				rankSet = true
			}
		}
		if (!rankSet){
			window.location.href = "/pricing?purchase=pro&interval=monthly";
		}
	  


      setError(""); // Clear any previous errors
    } catch (err) {
     alert(err);
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
      setError("Unable to load profile. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const [showDailyBonus, setShowDailyBonus] = useState(false);

  const checkDailyBonus = async () => {

		try {


			if (profile.lastClaimedAt) {
				const lastClaimedAt = new Date(profile.lastClaimedAt);
				const now = new Date();
				const diffTime = Math.abs(now - lastClaimedAt);
				const diffHours = diffTime / (1000 * 60 * 60);
				
				// Check if exactly 24 hours have passed (within a small margin)
				if (diffHours >= 24 && diffHours < 48) {
					const diffMinutes = (diffTime % (1000 * 60 * 60)) / (1000 * 60);
					const diffSeconds = (diffTime % (1000 * 60)) / 1000;
					setShowDailyBonus(true);
					
				}
			}

			if (profile.streak == 1){
				setShowDailyBonus(true);
			}


		} catch (err) {
			console.error(err);
		}
  };

  useEffect(() => {
    if (profile) {
      checkDailyBonus();
    }
  }, [profile]);

  // Check if user is authenticated
  const checkAuthentication = async () => {
    try {
      let accessToken = localStorage.getItem("accessToken");
	  if (!accessToken) return;
      const response = await fetch(`https://api.viralgpt.com/auth/validate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: accessToken }),
      });

      if (!response.ok) {
        throw new Error("Token is invalid or expired.");
      }
    } catch (err) {
      console.error(err);
      localStorage.removeItem("accessToken");
      setError("Session expired. Please log in again.");
      throw err;
    }
  };

  // Authenticate and fetch profile on component mount
  useEffect(() => {
    const authenticateAndFetchProfile = async () => {
      try {
        await checkAuthentication();
        await fetchProfileInfo();
      } catch {
        window.location.href = "/login"; // Redirect to login if authentication fails
      }
    };

    authenticateAndFetchProfile();
  }, []);

  if (loading) return (
  
		<div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
			<div className="d-flex flex-column align-items-center">
				<i className="fas fa-circle-notch fa-spin text-instagram" style={{ fontSize: "5rem"}}></i>
				<span className="visually-hidden">Loading...</span>
			</div>
		</div>
)
  if (error) return <p>{error}</p>;

  const selectProfile = (uuid) => {
	axios.post("https://api.viralgpt.com/auth/select", {
		profileid: uuid
	}, {
		headers: {
			Authorization: `Bearer ${localStorage.getItem("accessToken")}`
		}
	})
	.then(response => {
		window.location.reload();
	})
	.catch(error => {
		console.error("Error selecting profile:", error);
	});
  };
  


  return (
	<ProfileProvider profile={profile}>
	<div className="row mx-0 bg-slate-50">
	<Modal show={showLinkAccount} onHide={() => setLinkAccount(false)} centered size="lg">	
			<Modal.Header closeButton>	
				<Modal.Title>Link Account</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<RegisterSocial 
					show={showLinkAccount}
					onHide={() => setLinkAccount(false)}
				/>
			</Modal.Body>
		</Modal>
	  {/* LEFT COLUMN (Sidebar) - Visible on large screens */}
	  {/*<div className="col-lg-auto pt-lg-3 pe-4 bg-gray-50">

		<a href="/dashboard" className="text-decoration-none d-none d-lg-block">
		<span className="text-2xl font-semibold text-gray-900 flex items-center">
                <img src="/images/logo-icon.png" alt="Chart icon" className="h-8 w-8 mr-2" />
                <span className="text-instagram">ViralGPT</span>
              </span>
		</a>
		<Sidebar profile={profile} />
	  </div>*/}
  
	  {/* RIGHT COLUMN (Main Content) */}
	  
	  <div className="col-lg px-0 bg-gray-50" style={{ position: "relative", minHeight: "100vh" }}>
		{/* TOP BAR (Desktop only) */}
		<div className=" d-lg-block  top-0 end-0 w-100 ">

		<div className="float-start px-2 pt-2">
					<a href="/dashboard" className="text-decoration-none">
					<span className="text-2xl font-semibold text-gray-900 d-flex align-items-center">
						<img src="/images/logo-icon.png" alt="Chart icon" className="h-8 w-8 me-2" />
						<span className="text-instagram">ViralGPT</span>
					</span>
					</a>
				</div>
		  <div className="d-flex align-items-center justify-content-end h-100 pe-3">
			
		  <Dropdown align="end">
			{/* Flex container for Balance and Profile Image */}
			<div className="d-flex align-items-center justify-content-between w-100">

				
				<div className="d-flex align-items-center">
				

				<a href="/dashboard/bonus" className={`text-decoration-none ${showDailyBonus ? 'fa-bounce' : ''}`}>
					<span className={`me-2 `} style={{fontSize: "1.5rem"}}>🎁</span>
				</a>
				<Balance show={showBalance} onHide={() => setShowBalance(false)} profile={profile} />
				<span className="mx-2 border-instagram border-4 border-top-0 text-black p-2 cursor-pointer" onClick={() => setShowBalance(true)}>
					<i className="fa-solid fa-wallet me-2"></i>
					<strong>${profile.balance.toFixed(2)}</strong>
				</span>

          <Dropdown.Toggle
            variant="link"
            id="profile-dropdown"
            className="p-0 no-caret-toggle"
          >
            <img
              src={
                profile?.socials?.[profile?.selectedProfile]?.photo ||
                "/images/default.png"
              }
              alt="Profile"
              className="rounded-circle border"
              style={{ width: "40px", height: "40px" }}
            />
          </Dropdown.Toggle>
        </div>
      </div>

      {/* Dropdown Menu */}
       <Dropdown.Menu>
		<Dropdown.Item disabled className="text-black">Signed in as<br/>
		<strong>{profile.email}</strong></Dropdown.Item>
				<>
					<Dropdown.Divider />
					<Dropdown.Item href="/dashboard" className="text-black">
						<i className="fa-solid fa-gauge me-2" />
						Dashboard
					</Dropdown.Item>
					<Dropdown.Divider />
					<Dropdown.Item href="/dashboard/upgrade" className="text-white bg-instagram text-bold font-bold">
						<strong>Upgrade Your Account</strong>
					</Dropdown.Item>
				</>
			<Dropdown.Divider />
			{profile?.socials && Object.entries(profile.socials)
				.sort(([,a], [,b]) => (b.profileid === profile.selectedProfile) - (a.profileid === profile.selectedProfile))
				.map(([key, social]) => (
					<Dropdown.Item 
						key={key}
						className={`d-flex align-items-center ${social.profileid === profile.selectedProfile ? 'bg-light' : ''}`}
						onClick={() => selectProfile(social.profileid)}
					>
						<span className={`me-2 badge ${social.planName === 'pro' ? 'bg-instagram' : social.planName === 'basic' ? 'bg-dark' : 'bg-secondary'}`}>
							{(social.planName === 'pro' || social.planName === 'basic') && <i className="fa-solid fa-crown"></i>}
							
						</span>
						<img 
							src={social.photo || "/images/default.png"}
							alt="Profile"
							className="rounded-circle me-2"
							style={{width: "20px", height: "20px"}}
						/>
						{social.username.length > 16 ? `${social.username.slice(0, 12)}...` : social.username}
						
						{social.profileid === profile.selectedProfile && (
							<i className="fa-solid fa-check ms-auto text-instagram"></i>
						)}
					</Dropdown.Item>
				))}

			<Dropdown.Divider />
			<Dropdown.Item onClick={addAccount}>
				<i className="fa-solid fa-plus me-2" />
				Add Another Profile
			</Dropdown.Item>
			<Dropdown.Divider />
          <Dropdown.Item href="/dashboard/settings">
            <i className="fa-solid fa-gear me-2" />
            Account Settings
          </Dropdown.Item>
		  <Dropdown.Item href="/dashboard/settings?tab=billing">
            <i className="fa-solid fa-credit-card me-2" />
            Billing
          </Dropdown.Item>
          <Dropdown.Item href="/dashboard/support">
            <i className="fa-solid fa-headset me-2" />
            Support
          </Dropdown.Item>
		  <Dropdown.Divider />
          <Dropdown.Item className="text-danger" onClick={handleLogout}>
            <i className="fa-solid fa-arrow-right-from-bracket me-2" />
            Log Out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
		  </div>
		</div>
  
		{/* Spacing below the fixed top bar (so Outlet content isn’t hidden underneath) */}
		
		  <Outlet /> {/* Child routes */}
		
	  </div>
	</div>
  </ProfileProvider>
  
  );
}

export default Dashboard;
